<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path
            d="M6 7h12l1.2 13a1.8 1.8 0 0 1-1.8 2H6.6a1.8 1.8 0 0 1-1.8-2L6 7Z"
        />
        <path d="M9 10V6a3 3 0 0 1 6 0v4" />
    </svg>
</template>

<script>
export default { name: "ShoppingBagIcon" };
</script>
